var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4 0.229187H2.6C1.157 0.229187 0 1.39731 0 2.85419V18.6042C0 19.3004 0.273928 19.9681 0.761522 20.4603C1.24912 20.9526 1.91044 21.2292 2.6 21.2292H23.4C24.0896 21.2292 24.7509 20.9526 25.2385 20.4603C25.7261 19.9681 26 19.3004 26 18.6042V5.47919C26 4.02231 24.83 2.85419 23.4 2.85419H13L10.4 0.229187Z",
    fill: "url(#paint0_linear_2621_12454)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2621_12454",
    x1: 4.5339,
    y1: 21.2932,
    x2: 4.5339,
    y2: 0.165131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFFAF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.09ba3ab90482acbaac720f2387ac11f8.svg";
export { ForwardRef as ReactComponent };